<template>
  <div class="sc-message--tweet">
    <Tweet
      :id="data.twitterId"
      v-show="!hide"
      ref="twitter"
      :options="twitterOptions"
    />
    <div class="spinner" v-show="hide" />
  </div>
</template>

<script>
import { Tweet } from 'vue-tweet-embed'

export default {
  components: {
    Tweet
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    widgetwidth: {
      type: Number,
      required: true
    },
    widgetheight: {
      type: Number,
      required: true
    }
  },
  computed: {
    twitterOptions () {
      return {
        'hide_thread': 'true',
        'data-conversation': 'none',
        'data-cards': 'hidden'
      }
    },
    fontsize () {
      let fontsize = this.widgetwidth / 30
      if (fontsize > 12) {
        fontsize = 12
      }
      return fontsize
    }
  },
  data: () => ({
    interval: null,
    hide: true,
    width: 0
  }),
  mounted () {
    this.interval = setInterval(() => {
      this.hide = false
      const el = this.findElementWithClass(this.$refs.twitter.$el, 'CallToAction')
      if (el) {
        // This code is probably never going to be called anymore -> needs to go
        // This is additional styling which is no longer working as everything is in an iframe
        // but the tweets look good for now
        el.style.display = 'none'
        //console.log(this.$el.parentElement.parentElement)
        //try {
        //  this.width = this.$el.parentElement.parentElement.clientWidth - 10
        //} catch (_err) {
          this.width = this.$el.clientWidth - 10
        //}
        const container = this.findElementWithClass(this.$refs.twitter.$el, 'EmbeddedTweet-tweetContainer')
        container.style.paddingTop = '0px'
        container.style.paddingBottom = '0px'
        container.style.paddingLeft = '0px'
        container.style.paddingRight = '0px'
        const wrapper = this.findElementWithClass(this.$refs.twitter.$el, 'EmbeddedTweet-tweet')
        wrapper.style.paddingTop = '10px'
        wrapper.style.paddingBottom = '10px'
        wrapper.style.paddingLeft = '10px'
        wrapper.style.paddingRight = '10px'
        const username = this.findElementWithClass(this.$refs.twitter.$el, 'TweetAuthor-name')
        username.style.fontSize = this.fontsize + 'px'
        const screenname = this.findElementWithClass(this.$refs.twitter.$el, 'TweetAuthor-screenName')
        screenname.style.fontSize = this.fontsize + 'px'
        const tweettext = this.findElementWithClass(this.$refs.twitter.$el, 'Tweet-text')
        tweettext.style.fontSize = (this.fontsize * 1.5) + 'px'
        const quotetweettext = this.findElementWithClass(this.$refs.twitter.$el, 'QuoteTweet-text')
        if (quotetweettext) {
          quotetweettext.style.fontSize = (this.fontsize * 1.5) + 'px'
        }
        const tweetinfo = this.findElementWithClass(this.$refs.twitter.$el, 'TweetInfo')
        tweetinfo.style.fontSize = (this.fontsize) + 'px'
        const tweetembed = this.findElementWithClass(this.$refs.twitter.$el, 'EmbeddedTweet')
        if (tweetembed) {
          const tweetwidth = this.width + 8
          tweetembed.style.width = tweetwidth + 'px'
          tweetembed.style.maxWidth = tweetwidth + 'px'
          tweetembed.style.minWidth = tweetwidth + 'px'
        }
      }
    }, 2000)
  },
  beforeDestroy () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    findElementWithClass (el, classId) {
      for (const child of el.children) {
        if (child.className.split(' ').includes(classId)) {
          return child
        } else {
          const el = this.findElementWithClass(child, classId)
          if (el !== null) {
            return el
          }
        }
      }
      if (el.shadowRoot) {
        return this.findElementWithClass(el.shadowRoot, classId)
      }
      return null
    }
  }

}
</script>

<style lang="scss">
.sc-message--tweet {
  font-weight: 300;
  font-size: 0.8em;
  -webkit-font-smoothing: subpixel-antialiased;
  position: relative;
}
.tweetelement {
  border: 1px solid white;
  border-radius: 5px;
  background-color: rgba(255,255,255,0.2);
  .tweet {
    position: relative
  }
}
.twitter-tweet {
  margin: 0px !important;
  width: auto !important;
  max-width: 550px !important;
  min-width: 100px !important;
}
</style>
